import { defineStore } from 'pinia'
import i18n from '../plugins/i18n'
import Vue from 'vue'
import { forEachObjIndexed } from 'ramda'
import { LOCALE_MAP_INVERSE, LOCALE_MAP } from '@/constants'

export const useTranslationStore = defineStore({
  id: 'translation',
  actions: {
    loadTranslationByLocale (payload) {
      const { locale } = payload
      return Vue.prototype.$httpEZ.get(`/translation/${LOCALE_MAP_INVERSE[locale]}`)
        .then((response) => {
          // add returned locales to i18n
          forEachObjIndexed((responseMessages, responseLocale) => {
            // set the i18n messages for this locale
            i18n.setLocaleMessage(LOCALE_MAP[responseLocale], responseMessages)
          })(response.data)

          // set the current locale
          i18n.locale = locale

          // set the locale in local storage
          localStorage.locale = locale
        })
        .catch((error) => {
          throw error
        })
    },
  },
})
